<!-- 帮助使用 -->
<template>
    <div class="container">
        <div class="lefter">
            <Button
                class="theme-bc mt12 mb24 ml12"
                icon="md-add-circle"
                type="warning"
                @click="goAddCategory"
                >新增分类</Button
            >
            <div class="card-container">
                <div
                    :class="category_value == index ? 'card-active' : 'card'"
                    v-for="(item, index) of category_list"
                    :key="index"
                    @click="activeCategory(index, item)"
                >
                    <div>{{ item.name }}</div>
                    <div class="category-right">
                        <div>{{ item.sort }}</div>
                        <img
                            src="@/assets/help_add.png"
                            class="help-add-icon"
                            @click.stop="goAddCategory(item)"
                        />
                        <img
                            src="@/assets/help_del.png"
                            class="help-del-icon"
                            @click.stop="goDelCategory(item)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <Button
                class="theme-bc mb24"
                icon="md-add-circle"
                type="warning"
                @click="goAddModal"
                >新增帮助</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="title">
                    <div>{{ row.app ? row.app.title : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button
                            type="primary"
                            ghost
                            label="small"
                            @click="goAddModal(row)"
                            >编辑</Button
                        >
                        <Button
                            type="error"
                            ghost
                            label="small"
                            @click="goDel(row)"
                            >删除</Button
                        >
                    </div>
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>

        <!-- 新增/编辑 -->
        <Modal
            v-model="add_modal"
            :title="add_modal_title"
            width="700"
            :mask-closable="false"
        >
            <Form :model="form_item" label-position="right" :label-width="100">
                <FormItem label="帮助标题：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="form_item.name"
                        placeholder="请输入帮助标题"
                    ></Input>
                </FormItem>
                <FormItem label="序号：">
                    <Input
                        class="w300"
                        type="number"
                        v-model="form_item.sort"
                        placeholder="请输入序号"
                    ></Input>
                </FormItem>
                <FormItem label="帮助内容：">
                    <editor
                        class="w500"
                        :edtor-con="form_item.content"
                        :index="1"
                        @getContent="getEnContent"
                        @getContentchange="getEnContentchange"
                    />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
        <!-- 新增/编辑 -->
        <Modal
            v-model="add_category_modal"
            :title="add_category_modal_title"
            width="500"
            :mask-closable="false"
        >
            <Form
                :model="form_category_item"
                label-position="right"
                :label-width="100"
            >
                <FormItem label="分类名称：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="form_category_item.name"
                        placeholder="请输入分类名称"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelCategoryModal">取消</Button>
                <Button
                    class="theme-bc"
                    type="warning"
                    @click="submitCategoryModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    help_content,
    help_content_save,
    help_content_delete,
    help_content_one,
    help_category,
    help_category_sort,
    help_category_save,
    help_category_delete,
} from "@/api/index";
import editor from "@/components/editor/editor.vue";
export default {
    components: { editor },
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
                category_id: "",
                is_app: 0,
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "序号", key: "sort", align: "center" },
                { title: "帮助标题", key: "name", align: "center" },
                { title: "日期", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            add_modal: false,
            add_modal_title: "",
            form_item: {
                name: "",
                sort: "",
                id: "",
                category_id: "",
                content: "",
                app_id: "",
            },
            category_list: [],
            category_value: 0,
            add_category_modal: false,
            add_category_modal_title: "",
            form_category_item: {
                name: "",
                sort: "",
                id: "",
            },
        };
    },
    mounted() {
        this.getList();
        this.getCategoryList();
    },
    methods: {
        getCategoryList() {
            help_category().then((res) => {
                this.storePrams.category_id = res.data.data[0].id;
                this.form_item.category_id = res.data.data[0].id;
                this.category_list = res.data.data;
            });
        },
        getList() {
            help_content(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        getInfo(row) {
            help_content_one({ id: row.id }).then((res) => {
                this.form_item.name = res.data.name;
                this.form_item.sort = res.data.sort;
                this.form_item.id = res.data.id;
                this.form_item.content = res.data.content;
                this.form_item.app_id = res.data.app_id;
            });
        },
        goAddModal(row) {
            if (row.id) {
                this.add_modal_title = "编辑帮助";
                this.getInfo(row);
            } else {
                this.add_modal_title = "新增帮助";
                this.form_item.name = "";
                this.form_item.sort = "";
                this.form_item.id = "";
                this.form_item.content = "";
                this.form_item.app_id = "";
            }
            setTimeout(() => {
                this.add_modal = true;
            }, 300);
        },
        // 确定
        submitModal() {
            help_content_save(this.form_item)
                .then((res) => {
                    this.getList();
                    this.add_modal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.add_modal = false;
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    help_content_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        activeCategory(index, item) {
            this.category_value = index;
            if (item) {
                this.storePrams.category_id = item.id;
                this.form_item.category_id = item.id;
            }
            setTimeout(() => {
                this.getList();
            }, 300);
        },
        getSort() {
            help_category_sort()
                .then((res) => {
                    this.form_category_item.sort = res.data.sort;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goAddCategory(item) {
            if (item.id) {
                this.add_category_modal_title = "编辑分类";
                this.form_category_item.name = item.name;
                this.form_category_item.sort = item.sort;
                this.form_category_item.id = item.id;
            } else {
                this.add_category_modal_title = "新增分类";
                this.form_category_item.name = "";
                this.form_category_item.id = "";
                this.getSort();
            }
            setTimeout(() => {
                this.add_category_modal = true;
            }, 300);
        },
        // 确定
        submitCategoryModal() {
            help_category_save(this.form_category_item)
                .then((res) => {
                    this.getCategoryList();
                    this.add_category_modal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelCategoryModal() {
            this.add_category_modal = false;
        },
        goDelCategory(item) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    help_category_delete({ id: item.id })
                        .then((res) => {
                            this.getCategoryList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        //富文本
        getEnContent(detailData) {
            this.form_item.content = detailData.editorData;
        },
        getEnContentchange(detailData) {
            this.form_item.content = detailData.editorData;
        },
    },
};
</script>

<style scoped>
.container {
    width: 100%;
    display: flex;
}
.lefter {
    padding: 12px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    width: 30%;
    border-right: 1px solid #eee;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    width: 70%;
}
.text-align-right {
    text-align: right;
}
.card-container {
    width: 100%;
}
.card-active {
    padding: 10px;
    background: #e8eaf4;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    cursor: pointer;
}
.card {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
}
.category-right {
    margin-left: 24px;
    display: flex;
    align-items: center;
}
.help-add-icon {
    margin-left: 24px;
    min-width: 14px;
    width: 14px;
    min-height: 14px;
    height: 14px;
}
.help-del-icon {
    margin: 0 2px 0 12px;
    min-width: 20px;
    width: 20px;
    min-height: 20px;
    height: 20px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>